import React from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ObjetAgenda from '../../utils/ObjetAgenda';
import { useTranslation } from 'react-i18next';
import CardHomeAgenda from '../CardHomeAgenda/CardHomeAgenda';


const MultiAgenda = (props) => {

  const { t } = useTranslation();

  let CardAgendaHomeFilter = ObjetAgenda.filter((item) => {
    return item.isCardHome === true 
  })

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};



  return (

    <div >

      <div >
        <h1 className="text-center mb-5">{t('MultiAgenda.1')}</h1>
      </div>

      <Carousel
        swipeable={true}
        draggable={false}
        showDots={true}
        responsive={responsive}
        ssr={true} 
        infinite={true}
        autoPlay={props.deviceType !== "mobile" ? true : false}
        autoPlaySpeed={4000}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={2500}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        deviceType={props.deviceType}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px">

          {CardAgendaHomeFilter.map(item => { 
            return (   
            <CardHomeAgenda
                key={item.key}
                link={item.link} 
                imgbg={item.imgbg}
              />
              )}
            )};
        

        
	
      </Carousel>
    </div>
  )
}


export default MultiAgenda
